import React, { useRef, useState } from 'react'
import { Box, Button as ButtonG } from 'grommet'
import styled from 'styled-components'
import { setLightness } from 'polished'
import { isMobile } from 'react-device-detect'

import { device } from '../../theme/device'
import { cssVarPolished } from '../../utils/cssVarHelper'

const TooltipBox = styled(Box)`
  position: relative;
  &:after {
    position: absolute;
    left: ${props => (props.position === 'right' ? '4.6rem' : 'auto')};
    right: ${props => (props.position === 'left' ? '4.6rem' : 'auto')};
    top: 50%;
    transform: translateY(-50%);
    /* top:-37px; */
    /* min-width:100px; */
    /* min-height:10px; */
    line-height: 1.7rem;
    padding: ${props => (props.message ? '.7rem 1rem' : '0rem')};
    text-align: center;
    color: #fff;
    background-color: ${props => props.theme.global.colors.tooltipBg};
    font-size: 1.4rem;
    border-radius: 20px;
    content: '${props => props.message}';
    white-space: nowrap;
  }
`

const Button = styled(ButtonG)`
  background-color: ${props => {
    return props.colorB !== ''
      ? setLightness(
          0.85,
          cssVarPolished(props.theme.global.colors[props.colorB], '#222'),
        )
      : 'transparent'
  }};
  border-radius: 50%;
  padding: 12px;
  @media ${device.medium} {
    padding: 8px;
  }
`

const InlineTooltipButton = ({
  clicked,
  message,
  icon,
  position = 'right',
  color,
  badge = '',
}) => {
  const [over, setOver] = useState(false)
  const ref = useRef()

  return (
    <TooltipBox
      message={ref.current && over ? message : ''}
      position={position}
    >
      <Box badge={badge} flex={false}>
        <Button
          colorB={color}
          ref={ref}
          icon={icon}
          onClick={clicked}
          onFocus={isMobile ? undefined : () => setOver(true)}
          // {...(!isMobile
          //   ? {
          //       onMouseEnter: () => setOver(true),
          //       onMouseLeave: () => setOver(false),
          //     }
          //   : {})}
          onMouseEnter={isMobile ? clicked : () => setOver(true)}
          onMouseLeave={isMobile ? undefined : () => setOver(false)}
          onBlur={isMobile ? undefined : () => setOver(false)}
        />
      </Box>
    </TooltipBox>
  )
}

export default InlineTooltipButton
